module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('v-banner', {
    attrs: {
      "listImg": _vm.banners
    },
    on: {
      "imgClick": _vm.bannerClick
    }
  }), _vm._v(" "), (_vm.isFoxconn) ? _c('v-foxconn', {
    attrs: {
      "titleText": "首次充值满5元,送5元"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-charge', {
    attrs: {
      "text": _vm.balance
    },
    on: {
      "charge": _vm.recharge
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tiles"
  }, [_c('v-tile', {
    attrs: {
      "src": _vm.billImg,
      "content": "账单"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('month-bill')
      }
    }
  }), _vm._v(" "), _c('v-tile', {
    attrs: {
      "src": _vm.orderingImg,
      "content": "订餐"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('period-list')
      }
    }
  }), _vm._v(" "), _c('v-tile', {
    attrs: {
      "src": _vm.takemealImg,
      "content": "取餐"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('my-qr-code')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab', {
    staticClass: "tab-class",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "active1": true,
      "active2": false
    },
    on: {
      "click": _vm.tabClick
    }
  }), _vm._v(" "), (_vm.qrcodeShow) ? _c('v-qrcode-tip', {
    staticClass: "qrcode-class",
    on: {
      "click": _vm.qrcodeClick
    }
  }) : _vm._e(), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "长按二维码充值",
      "confirm-button-text": "关闭"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    ref: "qrcode",
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "padding": "20px 0"
    },
    attrs: {
      "id": "qrcode"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e9e8c83!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pg/main.vue
// module id = 836
// module chunks = 34